module.exports = __webpack_public_path__ + "static/media/upgreen.4bc5686c.svg";